import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { NavLink } from 'react-router-dom';
import { Theme } from '../../config/theme.js';

export default class NavigationItem extends Component {
  render() {
    return (
      <div className={css(styles.container)}>
        <NavLink className={css(styles.title)} to={this.props.url} activeClassName={css(styles.active_link)}>
          {this.props.title}
        </NavLink>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 40,
    height: 30,
    width: 80,
    textAlign: 'center',
  },
  active_link: {
    fontSize: 16,
    color: `${Theme.primary} !important`,
  },
  title: {
    flex: 1,
    fontSize: 15,
    fontFamily: 'Sailec',
    fontWeight: 'bold',
    textDecoration: 'none',
    transition: 'all 80ms ease-in-out',
    color: 'inherit',
    ':visited': {
      color: 'inherit',
    },
    ':active': {
      color: 'inherit',
    },
    ':hover': {
      fontSize: 16,
      color: Theme.primary,
    },
  }
})



// WEBPACK FOOTER //
// ./src/components/NavigationItem/index.js